<!--
 * @Autor: Hongting Yuan
 * @Date: 2021-11-27 14:59:55
 * @LastEditors: Hongting Yuan
 * @LastEditTime: 2021-12-08 21:20:30
 * @Description: 500报错页面
 * @FilePath: \Management-of-Scientific-Research-in-Universities-Front-master\src\components\error\error500.vue
-->

<template>
  <div style="margin-top: 180px;">
    <el-row>
      <el-col :span="13">
        <div style="display: flex;justify-content: right;align-items: center;margin: 0 20px;">
          <img src="../../assets/img/500.png">
        </div>
      </el-col>
      <el-col :span="11">
        <div>
          <div style="display: flex;justify-content: left;align-items: center;margin: 20px 30px;"><img src="../../assets/img/500500.png"></div>
          <div style="display: flex;justify-content: left;align-items: center;margin: 10px 35px;"><p>抱歉，服务器出错了</p></div>
          <div style="display: flex;justify-content: left;align-items: center;margin: 20px 55px;"><el-button type="success" @click="backHome">返回首页</el-button></div>
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import crypto from '../../crypto/crypto'
export default {
  name: 'Error500',
  methods: {
    backHome() {
      this.$router.push('/' + crypto.set('2'))
    }
  }
}
</script>

<style>

</style>
